export default __webpack_public_path__ + "static/sparkasse-fe3cbc2c22a4a3d2838863871eef191e.jpg";